import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'
import CircularProgress from '@material-ui/core/CircularProgress'
import { FONT_FAMILIES, MEDIA } from '../utils/styles'

const LoadingScreenWrapperStyle = `
  position: absolute;
  width: 100%;
  height: 100%
  align-self: stretch;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
`
const ScCircularLoadingWrapper = styled.div`
  ${LoadingScreenWrapperStyle}

  font-family: ${FONT_FAMILIES.SANSSERIF};
  font-size: 1.13rem;
  line-height: 1.72;

  ${MEDIA.TABLET`
    font-size: 1.19rem;
    line-height: 1.7;
  `}
  ${MEDIA.DESKTOP`
    font-size: 1.25rem;
    line-height: 1.7;
  `}
`

const ScAnimatedSiteLogoWrapper = styled.div`
  ${LoadingScreenWrapperStyle}

  svg {
    margin: auto;
    display: flex;
    width: 160px !important;
  }

  .Circle {
    fill: #fbd4ca;
  }

  .Circle {
    animation: bounce-1 1s;
    animation-direction: normal;
    animation-iteration-count: infinite;
    animate-timing-function: ease;
    transform-origin: center;
  }

  .Mom {
    animation: bounce-2 1s;
    animation-direction: normal;
    animation-iteration-count: infinite;
    animate-timing-function: ease;
    transform-origin: center;
  }

  @keyframes bounce-1 {
    0% {
      transform: scale(1, 1);
    }

    20% {
      transform: scale(1.05, 1.05);
    }

    50% {
      transform: scale(0.99, 0.99);
    }

    80% {
      transform: scale(1.001, 1.001);
    }

    100% {
      transform: scale(1, 1);
    }
  }

  @keyframes bounce-2 {
    0% {
      transform: scale(1, 1);
    }

    20% {
      transform: scale(1.2, 0.95);
    }

    50% {
      transform: scale(0.98, 1.02);
    }

    75% {
      transform: scale(1.01, 0.99);
    }

    90% {
      transform: scale(1, 1);
    }

    100% {
      transform: scale(1, 1);
    }
  }

  .dot {
    display: none;
  }

  .shape {
    cy: 165;
    cx: 256;
    r: 4;
    right: 50px;
    animation: moveCircle1 1s infinite;
  }

  @keyframes moveCircle1 {
    50% {
      cy: 135;
    }

    20% {
      cx: 286;
      r: 8;
    }
  }
`

const ScCircularProgress = styled(CircularProgress)`
  margin-bottom: 15px;
`

const LoadingScreen = ({ mode }) => {
  if (mode === 'siteLogo') {
    return (
      <ScAnimatedSiteLogoWrapper>
        <svg viewBox="0 0 300 300">
          <g id="Layer_4">
            <path
              className="Circle"
              d="M240.7,150.3c0,55.5-45,100.4-100.4,100.4s-100.4-45-100.4-100.4c0-55.5,45-100.4,100.4-100.4 S240.7,94.8,240.7,150.3"
            />
          </g>
          <g id="Layer_3">
            <path
              className="Mom"
              d="M49.9,80.2c-0.4,0.4-0.7,1-0.7,1.6c0,1.3,1.1,2.4,2.4,2.4c0.5,0,1-0.2,1.4-0.4c0,0,2.3-1.7,16.4-12.3 c12.5-9.3,22.8-4.9,19.3,12.4C83.4,110.7,73.3,144,70.4,158c-10.5,51.7-22,78.6-0.6,84.3c20.1,5.3,22.4-8.3,25.8-30.9 c1.6-10.8,6-37,10.6-60.2c4.5-23.3,16.8-61.5,27-61c10.2,0.5,7.2,21.4,7.5,39.9c0.3,18.5,0.5,27.8,12.3,29.7 c11.8,1.9,16-5.4,20.1-16.6c4-11.2,15-39.2,21.6-36.3c7.7,3.4-6.2,44.1-8.6,64.7c-2.2,18.3,2.3,27.9,8.7,33 c6.5,5.1,15.9,8,28.7,2.3c12.8-5.7,25.8-26.5,26-27c0.3-0.5,0.9-1.4-0.5-2.4c-1.4-1-2.5,0.4-2.5,0.4c-17.1,20-27,22.2-30.2,20.5 c-5.9-3.2-6.1-10.4-1.1-34.5c3-14.5,5.7-24.5,7.2-43.4c1.3-16.4-0.6-29.7-9.2-34.3c-18.6-9.9-34.1,19.6-44,39.9 c0,0,1-45.2-14.4-54.1c-11.2-6.6-26-0.3-39.9,19.8c0,0-0.1-25.5-17.5-32.6C83.6,53.3,71.8,61.8,62.8,69 C58.9,72.1,49.9,80.2,49.9,80.2"
            />
          </g>
          <g id="Layer_2">
            <path
              className="dot"
              d="M252.6,165.3c0-2,1.6-3.7,3.7-3.7c2,0,3.7,1.7,3.7,3.7c0,2-1.6,3.7-3.7,3.7C254.2,168.9,252.6,167.3,252.6,165.3"
            />
          </g>
          <circle className="shape" />
        </svg>
      </ScAnimatedSiteLogoWrapper>
    )
  } else if (mode === 'circular') {
    return (
      <ScCircularLoadingWrapper>
        <ScCircularProgress />
        <div>Loading...</div>
      </ScCircularLoadingWrapper>
    )
  }
}

LoadingScreen.propTypes = {
  mode: PropTypes.string,
}

LoadingScreen.defaultProps = {
  mode: 'siteLogo',
}

export default LoadingScreen
